import React from 'react';
import { NavLink } from 'react-router-dom';
import Badge from '../Badges/Badge';
import { ColourMod } from '../../Data/Enums/LayoutEnums';
import NestedDropdownMenu from '../DropdownMenus/NestedDropdownMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/pro-solid-svg-icons/faWarning';
import {useLayout} from "../../Providers/LayoutProvider";
import {faCaretLeft, faCaretRight } from '@fortawesome/pro-solid-svg-icons';

export interface MenuEntryInterface {
	title: string;
	url?: string;
	icon?: any;
	badgeCount?: number;
	showArrow?: boolean;
	callback?: any;
	disabled?: boolean;
	sectionHeader?: boolean;
	sectionDivider?: boolean;
	triggersChild?: boolean;
	children?: any;
	addonContent?: any;
}

const ItemMenuEntry: React.FC<MenuEntryInterface> = (entry) => {
	const { closeChildMenus, closeAllOpened, direction } = useLayout();

	let closeMenuTimer : any;

	if (entry.sectionHeader) {
		return (
			<div className={'item-menu-entry-title'}>
				<span>{entry.title}</span>
			</div>
		);
	}

	if (entry.sectionDivider) {
		return <div className={'item-menu-divider'} />;
	}

	const CallbackHandler = () => {
		if (entry.callback) {
			entry.callback();
			closeAllOpened();
		}
	};

	const RenderDropdownContent = () => {
		return (
			<>
				{!!entry.icon && entry.icon}

				<span>{entry.title}</span>

				{!!entry.badgeCount && !entry.addonContent && (
					<Badge count={entry.badgeCount} description={'true'} colour={ColourMod.Alert} />
				)}

				{!!entry.addonContent && (
					<div style={{ marginInlineStart: 'auto', pointerEvents: 'none'}}>
						{entry.addonContent}
					</div>
				)}

				{entry.showArrow && (
					<FontAwesomeIcon icon={direction === 'ltr' ? faCaretRight : faCaretLeft} fixedWidth={true} style={{ marginInlineStart: 'auto' }} />
				)}
			</>
		);
	};

	if (entry.children) {
		return (
			<NestedDropdownMenu
				id={'itemSubMenu'}
				subMenu={true}
				customTrigger={
					<div className={`item-menu-entry ${entry.disabled ? 'disabled' : ''}`}>
						<RenderDropdownContent />
					</div>
				}
			>
				{entry.children}
			</NestedDropdownMenu>
		);
	}

	if(!entry.url) {
		return(
			<div
				className={`item-menu-entry ${entry.disabled ? 'disabled' : ''}`}
				onClick={() => CallbackHandler()}
				title={entry.title}
			>
				<RenderDropdownContent />
			</div>
		)
	}

	return (
		<NavLink
			className={`item-menu-entry ${entry.disabled ? 'disabled' : ''}`}
			to={entry.url}
			title={entry.title}
		>
			<RenderDropdownContent />
		</NavLink>
	);
};

export default ItemMenuEntry;
